import { Component } from '@angular/core';
import { LeaderboardType } from '@fgb/core';

@Component({
  selector: 'fgb-predictor-v2-leaderboard-page',
  templateUrl: './predictor-v2-leaderboard-page.component.html',
  styleUrl: './predictor-v2-leaderboard-page.component.scss',
})
export class PredictorV2LeaderboardPageComponent {
  LeaderboardType: LeaderboardType = LeaderboardType.PredictorEntries;
}
